var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHubMenuViewDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M15.583 29.314h-9.28a1.193 1.193 0 0 1-1.241-1.135V8.126h5.042a1.852 1.852 0 0 0 1.872-1.813V2.104h13.343A1.202 1.202 0 0 1 26.56 3.24v11.976a.97.97 0 0 0 1.94 0V3.239A3.103 3.103 0 0 0 25.318.194H10.958a.97.97 0 0 0-.223.048h-.088c-.098.042-.189.098-.271.165L3.48 6.875a.97.97 0 0 0-.31.698V28.18a3.103 3.103 0 0 0 3.132 3.045h9.26a.97.97 0 0 0 0-1.94l.02.03zM10.065 6.216H7.011l3.054-2.86v2.86zm13.567 10.831a6.885 6.885 0 0 0-1.94-4.974 7.06 7.06 0 0 0-9.9-.252 6.904 6.904 0 0 0-.262 9.823 7.06 7.06 0 0 0 9.9.261 6.856 6.856 0 0 0 2.202-4.858zm-10.716 3.317a5.013 5.013 0 0 1 .194-7.118 5.159 5.159 0 0 1 7.215.194 4.975 4.975 0 0 1-.194 7.108 5.15 5.15 0 0 1-7.215-.184zm16.059 8.01l-5.896-6.158a.97.97 0 1 0-1.377 1.328l5.934 6.148a.97.97 0 0 0 1.377-1.319h-.038z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#636176",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHubMenuViewDocuments);
export default __webpack_public_path__ + "static/media/icon-hub-menu-view-documents.176004cc7fb1b718590311dccef141c1.svg";
export { ForwardRef as ReactComponent };